import { useNavigate, Link } from "react-router-dom";
import React from "react";
import "./Home.css";
import { AdminHeader } from "../Header/AdminHeader";

export { AdminHome };

function AdminHome() {
  return (
    <div className="admin-page-sec">
      <AdminHeader />
      <div className="admin-page-body relative d-flex">
        <div className="admin-page-content d-flex align-center justify-center">
          <div className="admin-home-list d-grid">
            <div className="admin-home-box d-flex flex-col justify-between">
              <h4 className="d-flex align-center">
                <span className="material-symbols-outlined">contacts</span> Users
              </h4>
              <p className="m-0">
                Create & Manage Users
              </p>
              <Link to="/admin-user-list/" className="btns andmin-link">
                Let's go{" "}
              </Link>
            </div>
            <div className="admin-home-box d-flex flex-col justify-between">
              <h4 className="d-flex align-center">
                <span className="material-symbols-outlined">work</span> Job Schedule
              </h4>
              <p className="m-0">
                View integration jobs
              </p>
              <Link to="/jobs-list" className="btns andmin-link">
                Let's go{" "}
              </Link>
            </div>
            {/* <div
              to=""
              className="admin-home-box d-flex flex-col justify-between"
            >
              <h4 className="d-flex align-center">
                <span className="material-symbols-outlined">manage_accounts</span>{" "}
                Role
              </h4>
              <p className="m-0">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem.
              </p>
              <Link to="/performa-invoice/" className="btns andmin-link">
                Let's go{" "}
              </Link>
            </div> */}
            {/* <div to="" className="admin-home-box d-flex flex-col justify-between">
              <h4 className="d-flex align-center"><span className="material-symbols-outlined">docs</span> Performa Invoice</h4>
              <p className="m-0">Sed ut perspiciatis unde omnis iste natus error sit voluptatem.</p>
              <Link to="/performa-invoice/" className="btns andmin-link">Let's go </Link>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
